import YandexPage from "./Yandex";
import OzonPage from "./Ozon";
import WbPages from "./Wb/Pages";

const OrderPages = {
    Wb: WbPages,
    Ozon: OzonPage,
    Yandex: YandexPage,
}

export default OrderPages